import { resumeMic } from "./mic";

/**
 * One audio element for the whole app. Browsers only let an element play
 * after a user gesture; reusing the same element lets the player start
 * right after a click on the home screen and keep going across passages
 * without another tap.
 */
let el: HTMLAudioElement | null = null;
let unlocked = false;
let silenceUrl: string | null = null;

export function sharedAudio() {
  if (!el) {
    el = new Audio();
    el.preload = "auto";
  }
  return el;
}

/** 0.1 s of 8 kHz 8-bit mono silence as a WAV blob URL. */
function silence() {
  const n = 800;
  const buf = new DataView(new ArrayBuffer(44 + n));
  const text = (at: number, s: string) => [...s].forEach((c, i) => buf.setUint8(at + i, c.charCodeAt(0)));
  text(0, "RIFF");
  buf.setUint32(4, 36 + n, true);
  text(8, "WAVEfmt ");
  buf.setUint32(16, 16, true);
  buf.setUint16(20, 1, true);
  buf.setUint16(22, 1, true);
  buf.setUint32(24, 8000, true);
  buf.setUint32(28, 8000, true);
  buf.setUint16(32, 1, true);
  buf.setUint16(34, 8, true);
  text(36, "data");
  buf.setUint32(40, n, true);
  for (let i = 0; i < n; i++) buf.setUint8(44 + i, 128);
  return URL.createObjectURL(new Blob([buf], { type: "audio/wav" }));
}

/** Call synchronously inside a click handler, before navigating to the player. */
export function unlockAudio() {
  resumeMic();
  if (unlocked) return;
  const a = sharedAudio();
  silenceUrl ??= silence();
  a.src = silenceUrl;
  a.play()
    .then(() => {
      unlocked = true;
    })
    .catch(() => {});
}
